import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const RocketIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.69274 4.91972C8.36389 3.35993 10.8876 1.73053 14.1451 1.73053C14.6124 1.73053 14.9912 2.10938 14.9912 2.57671C14.9912 5.4282 13.342 7.95267 11.8203 9.69179C11.4703 10.0918 10.8756 10.6945 10.2759 11.2803L10.8628 12.4541C10.9475 12.6235 10.9292 12.8262 10.8156 12.9777L8.90097 15.5305C8.61267 15.9149 8.00097 15.711 8.00097 15.2305V13.3592C7.92539 13.4197 7.85733 13.4732 7.79777 13.5194C7.71193 13.586 7.64364 13.6374 7.59582 13.673L7.59382 13.6745L7.52359 13.726L7.51959 13.7288L7.51726 13.7305C7.18099 13.9707 6.71916 13.9336 6.4264 13.6408L3.04179 10.2561C2.77198 9.98629 2.71613 9.56926 2.90544 9.23796L2.91648 9.21919L3.08529 8.94565C3.12575 8.8827 3.17301 8.81063 3.22699 8.73053H1.50097C1.02046 8.73053 0.816566 8.11883 1.20097 7.83053L3.75376 5.91594C3.90526 5.80231 4.10797 5.78403 4.27736 5.86873L5.25877 6.35943C5.79413 5.79904 6.33441 5.25417 6.69274 4.91972ZM2.91648 9.21919L2.90642 9.23626L2.90716 9.23496L2.91015 9.22978L2.91648 9.21919ZM5.00097 13.7305L3.00097 11.7305C2.00097 11.7305 1.00097 15.7305 1.00097 15.7305C1.00097 15.7305 5.00097 14.7305 5.00097 13.7305ZM11.75 6.23053C12.4403 6.23053 13 5.67089 13 4.98053C13 4.29017 12.4403 3.73053 11.75 3.73053C11.0596 3.73053 10.5 4.29017 10.5 4.98053C10.5 5.67089 11.0596 6.23053 11.75 6.23053Z"
		/>
	</svg>
))
